// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2fKfR","select":"Header_select__3HrxD","clinic":"Header_clinic__20oDq"};